import React, { useState } from "react";
import { UpsellPanelSteps, UserAccessLevelType } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetModel } from "../../hooks/useUpsellWidgetModelContext";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { Constants } from "../../../../constants";
import { isRequiredAccessLevelMatching } from "../../../../constants/upsellPanelHelpers";
import { useUpsellWidgetRedirect } from "../../hooks/useRedirectContext";
import { useActivateTrialMutation } from "../../services/hooks/useLoginMutation";
import { useForm } from "react-hook-form";
import ValidationErrorsSummary from "../UpSellWidgetContainer/ValidationErrorsSummary";

export const Step9PreProductActivation = () => {
    const model = useUpsellWidgetModel();
    const { baseProps, currentStep, onSubmitError, handleActivateTrialSuccess, setIsUpsellContainerLoading } = useUpsellWidgetContainer();
    const { redirectToUrl } = useUpsellWidgetRedirect();

    if (currentStep !== UpsellPanelSteps.Step9PreProductActivation) {
        return null;
    }
    const {
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [formErrors, setFormErrors] = useState(null);
    const activateMessage =
        isRequiredAccessLevelMatching(model?.requiredAccessLevel, UserAccessLevelType.IntelligentInvestor) ||
            isRequiredAccessLevelMatching(model?.requiredAccessLevel, UserAccessLevelType.Essentials)
            ? `Please click on the ACTIVATE button to activate your ${Constants.INTELLIGENT_INVESTOR} 15-day free trial`
            : isRequiredAccessLevelMatching(model?.requiredAccessLevel, UserAccessLevelType.Anonymous) ||
                isRequiredAccessLevelMatching(model?.requiredAccessLevel, UserAccessLevelType.Free)
                ? "Please click on the ACTIVATE button to finalise your membership"
                : "";
    const { mutate: activateTrial, isError: isActivateTrialError, isSuccess: isActivateTrialSuccess } = useActivateTrialMutation();

    const onActivateTrial = () => {
        setIsUpsellContainerLoading(true);
        activateTrial({
            entryPointUrl: baseProps.entryPointUrl,
            entryPoint: model.entryPoint,
            fromBuid: model.targetBuid,
            byPassPhoneVerification: !!(
                model.byPassPhoneVerification || baseProps.byPassPhoneVerification
              ),
            requiredAccessLevel: model.requiredAccessLevel ?? UserAccessLevelType.Anonymous,
            promoid: model.PromoID,
            affiliateCodeData: localStorage.getItem(Constants.AFFILIATE_CODE),
            urlReferrer: document.referrer
        }, {
            onSuccess: (response) => handleActivateTrialSuccess(response, redirectToUrl, setFormErrors),
            onError: (error) => onSubmitError(error)
        });
    }
    return (
        <div className="step9">
            {(isActivateTrialError || isActivateTrialSuccess) && errors && (<div className="upsell-container-content">
                <ValidationErrorsSummary validationErrors={{ ...errors, ...formErrors }} />
            </div>)}
            {activateMessage && <h3>{activateMessage}</h3>}
            <form
                className="join-form-inline form-is-custom form-disable-pristine-error"
                onSubmit={handleSubmit(onActivateTrial)}
                noValidate
            >
                <div className="row">
                    <div className="col col-xs-12 m-t mt-2-lg">
                        <button
                            className="btn btn-primary btn-wide font-15-no-line-height"
                            type="submit"
                        >
                            Activate
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

